// Reactive-form validators for the lake-level per-market fee editor.
import type { AbstractControl } from '@angular/forms';

/**
 * The dog fee is both-or-neither: either both purchase and sale are set, or both empty. A half-filled
 * dog fee is flagged with a `dogPair` error on the group.
 */
export function dogPairValidator(group: AbstractControl): { dogPair: true } | null {
  const purchase = group.get('dogPurchasePrice')?.value;
  const sale = group.get('dogSellingPrice')?.value;
  const purchaseSet = purchase !== null && purchase !== undefined && purchase !== '';
  const saleSet = sale !== null && sale !== undefined && sale !== '';
  return purchaseSet === saleSet ? null : { dogPair: true };
}
